<template>
  <div class="user">
    <div class="top">
      <div>
        <div>
          <img src="../../assets/img/user/user_icon.png" alt />
        </div>
        <div>
          <div class="van-ellipsis">{{dataDetail.shop_name}}</div>
          <div class=" name_tel flex_c_c" style="margin:0.07rem 0 0.05rem">
            <div class="van-ellipsis" style="margin-right:0.1rem">{{dataDetail.login_user_realname}}</div>
            <div class="top_tag1" v-if="dataDetail.login_user_role_type==1">店长</div>
            <div
              v-if="list&&dataDetail.login_user_role_type!=1"
              class="top_tag2"
            >{{list[dataDetail.login_user_role_type+'']}}</div>
          </div>
          <div class="name_tel">{{dataDetail.mobile}}</div>
        </div>
        <div class="showBox">
          <img
            v-if="dataDetail.login_user_role_type == 1"
            @click="showBox"
            src="../../assets/img/user/user_edit.png"
            alt
          />
        </div>
      </div>
    </div>
    <div class="center" v-if="count != -1">
      <van-grid :column-num="3" :border="false">
        <van-grid-item
          @click="$router.push('/mine/employee/employeeManage')"
          v-if="dataDetail.login_user_role_type == 1"
        >
          <img src="../../assets/img/user/user_manage.png" alt class="user-icon" />
          <div class="user-text">员工管理</div>
        </van-grid-item>
        <van-grid-item
          @click="$router.push('/mine/role/roleManage')"
          v-if="dataDetail.login_user_role_type == 1"
        >
          <img src="../../assets/img/user/role_manage.png" alt class="user-icon" />
          <div class="user-text">角色管理</div>
        </van-grid-item>

        <van-grid-item @click="$router.push('/mine/myData/myData')">
          <img src="../../assets/img/user/my_data.png" alt class="user-icon" />
          <div class="user-text">个人资料</div>
        </van-grid-item>

        <!-- <van-grid-item @click="$router.push('/mine/bill/billManage')">
          <img src="../../assets/img/user/sale_manage.png" alt="" class="user-icon">
          <div class="user-text">货品管理</div>
        </van-grid-item>-->

        <van-grid-item @click="$router.push('/mine/printer/printerManage')">
          <img src="../../assets/img/user/printer.png" alt class="user-icon" />
          <div class="user-text">打印机管理</div>
        </van-grid-item>
        <van-grid-item v-if="count>1" @click="$router.push('/mine/sys/shopList')">
          <img src="../../assets/img/user/me_shop.png" alt class="user-icon" />
          <div class="user-text">切换店铺</div>
        </van-grid-item>
        <van-grid-item @click="$router.push('/mine/sys/sysSet')">
          <img src="../../assets/img/user/sys_set.png" alt class="user-icon" />
          <div class="user-text">系统设置</div>
        </van-grid-item>
        <van-grid-item @click="$router.push('/mine/feedBack/feedBackUpload')">
          <img src="../../assets/img/user/advice_view.png" alt class="user-icon" />
          <div class="user-text">意见反馈</div>
        </van-grid-item>
      </van-grid>
    </div>

    <van-dialog
      v-model="showChangeName"
      title="请输入店铺名称"
      show-cancel-button
      @confirm="handleConfirm"
    >
      <div class="showChangeName_box">
        <input type="text" v-model="shop_name" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getShopData, setShopName, myShopList } from "@/api/layout/user";
import { employee_role_list } from "@/api/work/mine/employee";
export default {
  name: "user",
  data() {
    return {
      dataDetail: {
        shop_name: "",
        mobile: "",
        login_user_realname: ""
      },
      showChangeName: false,
      shop_name: "",
      count: -1,
      list: null
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getData();
    });
  },
  created() {
    // this.getData();
    myShopList().then(res => {
      if (res.code == 200) {
        this.count = res.data.count;
      }
    });
  },
  mounted() {
    
  },
  methods: {
    // 获取数据
    getData() {
      getShopData().then(res => {
        if (res.code == 200) {
          this.dataDetail.shop_name = res.data.shop_name || "我的商铺";
          this.dataDetail.mobile = res.data.login_user_mobile || "";
          this.dataDetail.login_user_role_type = res.data.login_user_role_type;
          this.dataDetail.login_user_realname = res.data.login_user_realname;
        }
      });
      employee_role_list().then(res => {
        if (res.code == 200) {
          let list = {};
          for (let i = 0; i < res.data.length; i++) {
            const item = res.data[i];
            list[item.id + ""] = item.name;
          }
          this.list = list;
        }
      });
    },

    showBox() {
      this.shop_name = this.dataDetail.shop_name;
      this.showChangeName = true;
    },

    handleConfirm() {
      setShopName({ shop_name: this.shop_name }).then(res => {
        if (res.code == 200) {
          this.$toast.success(res.message);
          this.getData();
        }
      });
    }
  }
};
</script>


<style lang="less" scoped>
.user {
  background-color: #fff;
  min-height: calc(100vh - 50px);
  .flex_c_c {
    display: flex;
   align-items: center;
  }
  .top {
    width: 100%;
    height: 2.5rem;
    background: url("../../assets/img/user/user_bg.png") no-repeat center;
    background-size: 100% 100%;
    &:before {
      content: ".";
      display: block;
      height: 0;
      visibility: hidden;
    }
    .top_tag2 {
      // box-sizing: border-box;
      flex-shrink: 0;
      font-size: 0.24rem;
      padding: 0.02rem 0.1rem;
      border: 1px solid #31b158;
      color: #31b158;
    
      border-radius: 0.04rem;
    }
    .top_tag1 {
      // box-sizing: border-box;
      flex-shrink: 0;
      font-size: 0.24rem;
      padding: 0.02rem 0.1rem;
      border: 1px solid rgba(236, 151, 29, 1);
      color: rgba(236, 151, 29, 1);
      border-radius: 0.04rem;
    }
    margin-bottom: 1.2rem;
    > div {
      width: 5.93rem;
      // height: 1.27rem;
      margin: 1.49rem auto 0;
      box-sizing: border-box;
      background-color: #fff;
      border-radius: 0.1rem;
      box-shadow: 0px 0.02rem 0.21rem 0px rgba(18, 144, 56, 0.2);
      padding: 0.2rem 0.3rem 0.1rem 0.4rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      > div:first-child {
        img {
          width: 1rem;
          height: 1rem;
        }
      }
      > div:nth-child(2) {
        width: 3.3rem;
        > div:first-child {
          font-size: 0.36rem;
          color: #333333;
          font-weight: bold;
          // margin-bottom: 0.1rem;
        }
      }
      > div:last-child {
        img {
          width: 0.36rem;
          height: 0.36rem;
        }
      }
    }
  }
  .center {
    width: 100%;
    overflow: hidden;
    padding: 0 0.3rem;
    box-sizing: border-box;
  }
  .user-text {
    font-weight: bold;
  }
  .user-icon {
    height: 0.54rem;
    margin-bottom: 0.2rem;
  }
  .showBox {
    width: 0.5rem;
    height: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .showChangeName_box {
    width: 90%;
    margin: 0.3rem auto;
    height: 0.8rem;
    border-radius: 0.1rem;
    border: 0.02rem solid #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    input {
      border: none;
      width: 95%;
      color: #333;
    }
  }
}
</style>